export default __webpack_public_path__ + "static/combiphar-background-021b4c9bd247f04580876ef655e3577f.png";